import request, { authOptions } from 'api/requestUtils'
import type { definitions } from '@luxuryescapes/contract-svc-agent'

type CreateUserWithSocieteRequest = definitions['createUserWithSocieteRequest']
type CreateUserWithSocieteResponse = {
  email: string
  confirmationRequired: boolean
}

export interface CreateUserWithSocieteParams {
  email: string
  password: string
  surname: string
  givenName: string
  region: 'AU' | 'NZ' | 'US' | 'GB'
  phonePrefix?: string
  phone?: string
  brand?: 'leagenthub' | 'leagenthub_cvfr'
}

async function requestPostCreateUserWithSociete(params: CreateUserWithSocieteParams) {
  const requestBody: CreateUserWithSocieteRequest = {
    email: params.email,
    password: params.password,
    surname: params.surname,
    givenName: params.givenName,
    region: params.region,
    phonePrefix: params.phonePrefix,
    phone: params.phone,
    brand: params.brand,
  }

  const response = await request.post<App.ApiResponse<CreateUserWithSocieteResponse>, CreateUserWithSocieteRequest>(
    '/api/agent/user/create-with-societe',
    requestBody,
    authOptions(),
  )

  return response.result
}

export default requestPostCreateUserWithSociete
